let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7GuDD")).then(() => parcelRequire('7Ua2l'));